import React, { useState } from 'react';
import { useEssentials } from '../../../utils/hooks/useEssentials';
import { motion, AnimatePresence, wrap } from 'motion/react';
import { variants, transition, nextVariants, prevVariants, nameVariants } from './variants';
import styles from './Carousel.module.css';


export default function Carousel({show}) {

    const { essentials, loading } = useEssentials();
    const [[imageCount, direction], setImageCount] = useState([0,0]);
    const activeIndex = wrap(0, essentials?.length, imageCount);

    const swipeToImage = swipeDirection => {
        setImageCount([imageCount + swipeDirection, swipeDirection]);
    };

    const handleDragEnd = dragInfo => {
        const draggedDistance = dragInfo.offset.x;
        const swipeThreshold = 50;
        if (draggedDistance > swipeThreshold) {
            swipeToImage(-1);
        } else if (draggedDistance < -swipeThreshold) {
            swipeToImage(1);
        }
    };

    const handleReturn = () => {
        if (loading) {
            return <div className={styles.spinnerContainer}><i className='fas fa-spinner fa-spin-pulse' /></div>;
        } else {
            return (
                <>
                <AnimatePresence initial={false} custom={direction}>
                    <motion.div
                        key={essentials[activeIndex].item_name}
                        custom={direction}
                        variants={nameVariants}
                        initial='incoming'
                        animate='active'
                        exit='exit'
                        transition={transition}
                        className={styles.itemName}
                    >
                        {essentials[activeIndex].item_name}
                    </motion.div>
                </AnimatePresence>
                <div className={styles.carouselContainer}>
                    <div className={styles.carousel}>
                        <AnimatePresence initial={false} custom={direction}>
                            <motion.div 
                                key={`prev-${activeIndex}`}
                                style={{backgroundImage: `url(${essentials[(activeIndex === 0 ? essentials.length - 1 : activeIndex - 1)].image_url})`}}
                                custom={direction}
                                variants={prevVariants}
                                initial='incoming'
                                animate='active'
                                exit='exit'
                                transition={transition}
                                className={styles.prevImage}
                            />
                            <motion.div
                                key={`current-${activeIndex}`}
                                style={{backgroundImage: `url(${essentials[activeIndex].image_url})`}}
                                custom={direction}
                                variants={variants}
                                initial='incoming'
                                animate='active'
                                exit='exit'
                                transition={transition}
                                drag='x'
                                dragConstraints={{left: 0, right: 0}}
                                dragElastic={1}
                                onDragEnd={(_, dragInfo) => handleDragEnd(dragInfo)}
                                className={styles.image}
                            />
                            <motion.div
                                key={`next-${activeIndex}`}
                                style={{backgroundImage: `url(${essentials[(activeIndex + 1) % essentials.length].image_url})`}}
                                custom={direction}
                                variants={nextVariants}
                                initial='incoming'
                                animate='active'
                                exit='exit'
                                transition={transition}
                                className={styles.nextImage}
                            />
                        </AnimatePresence>
                    </div>
                </div>
                </>
            );
        }
    };

    return (
        <div className={styles.container} style={show ? {display: 'flex'} : {display: 'none', visibility: 'hidden'}}>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <div className={styles.title}>Top 30 Essentials</div>
                    <div className={styles.subtitle}>Shop from our Top Business Essentials</div>
                </div>
                {!loading && <a href={`${essentials[activeIndex]?.store_url}`} target='_blank' rel='noreferrer' className={styles.viewInStore}>View in Store</a>}
            </div>
            <div className={styles.content}>
                <button className={styles.prevItem} onClick={() => swipeToImage(-1)} disabled={loading}><i className='fas fa-chevron-left' /></button> 
                <button className={styles.nextItem} onClick={() => swipeToImage(1)} disabled={loading}><i className='fas fa-chevron-right' /></button>
                {handleReturn()}
            </div>
        </div>
    );
};